<template>
  <div class="quest-filter" v-if="filterData !== null">
    <Filter :selected-filters-count="selectedFiltersCount" @filter-updated="onFilterUpdated"
            @filter-reset="onFilterReset" @filter-cancelled="resetFilterDraft">
      <FilterCategoryBlock v-for="category in filterCategories" :key="category.key"
                           :filter-category="category" :block-data="filterDataDraft[category.key]"
                           @updated="filterBlockUpdated"></FilterCategoryBlock>

      <div class="px-3 pt-3 mt-1">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" :id="'filter-include-completed_' + uuid"
                 v-model="filterDataDraft['hideCompletedQuests']"/>
          <label class="form-check-label" :for="'filter-include-completed_' + uuid">Verberg gespeelde
            activiteiten</label>
        </div>
      </div>
      <!--
      <div class="px-3 pb-1 mt-1">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" :id="'filter-only-favorites_' + uuid"
                 v-model="filterDataDraft['showOnlyFavorites']"/>
          <label class="form-check-label" :for="'filter-only-favorites_' + uuid">Toon enkel favorieten</label>
        </div>
      </div>
      -->
    </Filter>
  </div>
</template>

<script>
import FilterCategoryBlock from "@/components/Filter/FilterCategoryBlock";
import QuestFilterMixin from "@/mixins/QuestFilter";
import Filter from "@/components/Filter/Filter";
import log from "@/utils/logger";

let uuid = 0;

export default {
  name: "QuestFilter",
  components: { Filter, FilterCategoryBlock },
  mixins: [ QuestFilterMixin ],
  emits: [ "filter-updated" ],
  data()
  {
    return {
      filterData: null,
      filterDataDraft: null,
    }
  },
  computed: {
    filterIsEmpty()
    {
      let isEmpty = true;

      for (let i = 0; i < this.filterCategories.length; i++)
      {
        if (Object.prototype.hasOwnProperty.call(this.filterData, this.filterCategories[i].key) &&
            this.filterData[this.filterCategories[i].key].length > 0)
        {
          isEmpty = false;
          break;
        }
      }

      if (isEmpty)
      {
        isEmpty = isEmpty && !this.filterData['hideCompletedQuests'] && !this.filterData['showOnlyFavorites'];
      }

      return isEmpty;
    },
    selectedFiltersCount()
    {
      let appliedFilters = 0;

      for (const value of Object.values(this.filterDataDraft))
      {
        appliedFilters += value ? value.length : 0;
      }

      return appliedFilters;
    }
  },
  methods: {
    onFilterReset()
    {
      log.debug("Resetting filter - %o", this.filterDataDraft);
      this.resetFilterData(this.filterDataDraft);
      this.filterData = JSON.parse(JSON.stringify(this.filterDataDraft));
      this.$emit("filter-updated", this.filterData, this.filterIsEmpty);
      this.saveFilterToSessionStorage(this.filterData, this.filterIsEmpty);
    },
    resetFilterDraft()
    {
      this.filterDataDraft = JSON.parse(JSON.stringify(this.filterData));
    },
    onFilterUpdated()
    {
      log.debug("Updating quest filter");
      console.log(this.filterDataDraft);
      this.filterData = JSON.parse(JSON.stringify(this.filterDataDraft));
      this.$emit("filter-updated", this.filterData, this.filterIsEmpty);
      this.saveFilterToSessionStorage(this.filterData, this.filterIsEmpty);

    },
    saveFilterToSessionStorage(filterData, isEmpty)
    {
      let data = {
        filterData: filterData,
        isEmpty: isEmpty
      }

      sessionStorage.setItem('LKP_activity_filter', JSON.stringify(data));

    },
    filterBlockUpdated(updateData)
    {
      if (updateData && Object.prototype.hasOwnProperty.call(this.filterDataDraft, updateData.category))
      {
        if (updateData.checked)
        {
          if (!this.filterDataDraft[updateData.category].includes(updateData.value))
          {
            this.filterDataDraft[updateData.category].push(updateData.value);
          }
        }
        else
        {
          const valueIndex = this.filterDataDraft[updateData.category].indexOf(updateData.value);
          if (valueIndex > -1)
          {
            this.filterDataDraft[updateData.category].splice(valueIndex, 1);
          }
        }
      }
    },
    fetchInitialFilters()
    {
      // TODO - fetch initial filters from sessionStorage?
      let data = sessionStorage.getItem('LKP_activity_filter');
      let parsed = JSON.parse(data);

      if (parsed?.filterData)
      {
        this.filterDataDraft = JSON.parse(data)?.filterData;
        this.onFilterUpdated();
      }

    },
    resetFilterData(filterData)
    {
      for (let i = 0; i < this.filterCategories.length; i++)
      {
        filterData[this.filterCategories[i].key] = [];
      }

      filterData['hideCompletedQuests'] = false;
      filterData['showOnlyFavorites'] = false;
    }
  },
  created()
  {
    this.fetchInitialFilters();

    if (this.filterData === null)
    {
      this.filterData = {};
      this.resetFilterData(this.filterData);
      this.filterDataDraft = JSON.parse(JSON.stringify(this.filterData));
    }
  },
  beforeCreate()
  {
    this.uuid = uuid.toString();
    uuid += 1;
  }
}
</script>

<style scoped>

</style>